module.exports = __webpack_public_path__ + "img/9788952746474.0f316849.jpg";